import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const PickerAspectGroupContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.pickerAspectGroupContainer, style]} />
);

const styles = StyleSheet.create({
  pickerAspectGroupContainer: {
    width: '100%',
  },
});
